import axios from 'axios';

const baseUrl = `${process.env.VUE_APP_PORTAUS_API_URL}:${process.env.VUE_APP_PORTAUS_API_PORT}/API/latest/admin/sage-integration`;

export default {
  fetchConfig () {
    return axios.get(baseUrl).then(results => results.data);
  },
  updateConfig (payload) {
    return axios.put(baseUrl, payload).then(results => results.data);
  },
  syncInvoices () {
    return axios.post(`${baseUrl}/sync/invoices`).then(results => results.data);
  },
  syncPayments () {
    return axios.post(`${baseUrl}/sync/payments`).then(results => results.data);
  },
  syncCreditNotes () {
    return axios.post(`${baseUrl}/sync/credit-notes`).then(results => results.data);
  },
  syncAll () {
    return axios.post(`${baseUrl}/sync/all`).then(results => results.data);
  },
};
